import React, {FC} from 'react'
import MainAsideMenuLayout from "@layouts/mainAsideMenuLayout/MainAsideMenuLayout";


const PlanPage: FC<any> = (props) => {

  let {} = props

  return (
    <MainAsideMenuLayout>
      {/*<BackLinkLayout>*/}
      <div>PlanPage
      </div>
      {/*</BackLinkLayout>*/}
    </MainAsideMenuLayout>
  )
}

export default PlanPage;